import { db } from "../config/firebaseConfig";
import { collection } from "firebase/firestore";
export const chatsCollection = collection(db, "chats");
export const chatListDescription =
  "Begin a conversation by selecting a chat on the left. Type your messages here, and enjoy seamless communication.";
export const Colors = {
  strokeColor: "#acdce7",
};
